<template>
  <transition name="fade">
    <div v-if="visible" class="fixed inset-0 z-[90] flex items-center justify-center bg-black/70"
         @click.self="handleSkip">
      <div
          :class="['relative w-full max-w-md mx-4 p-6 md:p-8 border-4 transition-all', isEasy ? 'bg-amber-50 border-amber-800/50 sepia-shadow' : 'card-dark-rich border-amber-600/60 shadow-2xl shadow-black/40']"
          style="border-radius: 8px;">

        <!-- Header with Mascot -->
        <div class="text-center space-y-4 mb-6">
          <Mascot size="w-20 h-20 md:w-24 md:h-24" mood="thinking"/>
          <h2 :class="['text-2xl md:text-3xl font-serif-display font-bold', isEasy ? 'ink-text' : 'text-amber-100']">
            Before You Begin...
          </h2>
        </div>

        <!-- Offer Message -->
        <div
            :class="['p-4 mb-6 border-2 text-center', isEasy ? 'bg-amber-100/50 border-amber-700/30' : 'bg-stone-800/50 border-slate-600/50']"
            style="border-radius: 6px;">
          <p :class="['text-lg font-serif-body font-semibold mb-2', isEasy ? 'ink-text' : 'text-amber-100']">
            Watch a short ad to earn
          </p>
          <div class="flex items-center justify-center gap-2 my-3">
            <div class="flex gap-1">
              <div :class="['w-4 h-6 border-2', isEasy ? 'bg-blue-500 border-blue-800' : 'bg-blue-600 border-blue-400']"
                   style="border-radius: 2px; transform: rotate(-5deg);"></div>
              <div :class="['w-4 h-6 border-2', isEasy ? 'bg-blue-500 border-blue-800' : 'bg-blue-600 border-blue-400']"
                   style="border-radius: 2px; transform: rotate(-5deg);"></div>
            </div>
            <span
                :class="['text-2xl font-serif-display font-bold', isEasy ? 'text-blue-800' : 'text-blue-400']">+2</span>
            <span :class="['text-lg font-serif-body font-semibold', isEasy ? 'text-amber-800' : 'text-amber-300']">Extra Passes!</span>
          </div>
          <p :class="['text-sm font-serif-body', isEasy ? 'text-amber-800/70' : 'text-amber-300/70']">
            Start with 3 passes instead of 1 (the longer you survive, the higher your score!)
          </p>
        </div>

        <!-- Action Buttons -->
        <div class="space-y-3">
          <button
              @click="handleWatchAd"
              :disabled="loading"
              :class="['w-full py-4 font-serif-display font-bold text-lg border-4 transition-all transform hover:scale-[1.02]', isEasy ? 'bg-amber-700 hover:bg-amber-600 border-amber-900 text-amber-50' : 'bg-amber-700 hover:bg-amber-500 border-amber-900 text-white', loading ? 'opacity-50 cursor-not-allowed' : '']"
              style="border-radius: 8px;"
          >
            <span v-if="loading">Loading...</span>
            <span v-else>Watch Ad</span>
          </button>

          <button
              @click="handleSkip"
              :disabled="loading"
              :class="['w-full py-3 font-serif-body font-semibold text-base border-2 transition-colors', isEasy ? 'bg-transparent border-amber-700/50 text-amber-800 hover:bg-amber-100' : 'bg-transparent border-amber-700/40 text-amber-300 hover:bg-stone-800', loading ? 'opacity-50 cursor-not-allowed' : '']"
              style="border-radius: 6px;"
          >
            No Thanks
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import {ref} from 'vue'
import Mascot from './Mascot.vue'

defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  isEasy: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['watch-ad', 'skip'])

const loading = ref(false)

const handleWatchAd = () => {
  loading.value = true
  emit('watch-ad')
}

const handleSkip = () => {
  if (loading.value) return
  emit('skip')
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.sepia-shadow {
  box-shadow: 4px 4px 0px rgba(120, 80, 40, 0.2);
}

.card-dark-rich {
  background: radial-gradient(circle at top left, #2d2a28, #1a1817);
}

.ink-text {
  color: #2c1810;
}
</style>
